<template>
    <div style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <!-- 导航栏 -->
        <van-nav-bar title="通知公告记录" left-arrow @click-left="onClickLeft" />
            <div style="padding: 10px 16px;">
				
				<van-row style="padding: 10px 0">
				    <van-col span="8" style="color:#777;font-size: 14px">标题</van-col>
				    <van-col span="16" style="font-size: 14px">{{notice.title}}</van-col>
				</van-row>
                <van-row style="padding: 10px 0">
                    <van-col span="8" style="color:#777;font-size: 14px">姓名</van-col>
                    <van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
<!--                        <img v-if="consult.userInfo" :src="consult.userInfo.headImgUrl" width="20" style="border-radius: 10px;"> -->
                        {{notice.userName}}
                    </van-col>
                </van-row>
				<van-row style="padding: 10px 0">
					<van-col span="8" style="color:#777;font-size: 14px">指派单位/律师 </van-col>
					<van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
<!--                        <img v-if="consult.userInfo" :src="consult.userInfo.headImgUrl" width="20" style="border-radius: 10px;"> -->
						{{notice.attorney}}
					</van-col>
				</van-row>
				<van-row style="padding: 10px 0">
					<van-col span="8" style="color:#777;font-size: 14px">办理单位</van-col>
					<van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
<!--                        <img v-if="consult.userInfo" :src="consult.userInfo.headImgUrl" width="20" style="border-radius: 10px;"> -->
						{{notice.groupName}}
					</van-col>
				</van-row>
                <van-row style="padding:10px  0">
                    <van-col span="8" style="color:#777;font-size: 14px">联系方式</van-col>
                    <van-col span="16" style="font-size: 14px">{{notice.attorneyPhone}}</van-col>
                </van-row>

                <van-row style="padding: 10px 0">
                    <van-col span="8" style="color:#777;font-size: 14px">创建时间</van-col>
                    <van-col span="16" style="font-size: 14px">{{notice.createDate}}</van-col>
                </van-row>
				<van-row style="padding: 10px 0">
					<van-col span="8" style="color:#777;font-size: 14px">备注</van-col>
					<van-col span="16" style="font-size: 14px;display: flex;flex-direction: row;justify-content: start;align-items: center;">
<!--                        <img v-if="consult.userInfo" :src="consult.userInfo.headImgUrl" width="20" style="border-radius: 10px;"> -->
						{{notice.message}}
					</van-col>
				</van-row>
           </div>
    </div>
</template>

<script>
  import {Dialog,Toast} from 'vant';
  import axios from '../common/axios';
  // import {responseCodes,consultReplyTypes,userTypes,consultStatus} from '../common/const'

  export default {
    name: "ConsultHistory.vue",
    data() {
      return {
      
        isCloseConsult:true,
        message:'',
        replies:[]
      };
    },
    computed:{
      notice(){
		return this.$route.params.item
      },
      userType(){
        return this.$route.params.userType
      },
      isConsultCanReply(){
        let result={
          flag:false,
          msg:'',
        }

      
      }
    },
    mounted(){
    
    },
    methods: {
		  onClickLeft() {
			this.$router.back();
		  },

		}
	}
   


</script>

<style scoped>
    .van-cell__title{
        font-size: 16px;
        flex: 3;
    }
    .van-cell:not(:last-child)::after{
        right: 16px;
    }
    .van-field__value::after{
        border: none;
    }
</style>